// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import msal from 'vue-msal'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.use(msal, {
  auth: {
    clientId: 'a1298260-7759-4078-af7a-89128dbdfc7d',
    authority: 'https://login.microsoftonline.com/e5b034a6-2ef6-4204-a633-e58c0c0b211e/',
  },
  graph: {
    callAfterInit: true,
  },
  cache: {
    cacheLocation: "localStorage"
  }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js